<template>
    <v-card class="flex pa-0 background-2 round-card pb-offset" v-if="!$store.getters.progress">
        <v-card-title class="pa-3">
            <p class="pl-2 pl-xl-3">Interventi</p>
            <v-spacer></v-spacer>
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" @click="$eventBusUtility.exportCSV(headers, items, 'Interventi')" slot="activator" icon :disabled="items.length == 0">
                        <v-icon>play_for_work</v-icon>
                    </v-btn>
                </template>
                <span>Esporta CSV</span>
            </v-tooltip>
        </v-card-title>
        <v-divider></v-divider>
        <v-container class="pa-4" fluid>
            <fields-generator
                :fieldsset.sync="fieldsset"
                :model="model"
                ref="fieldsgenerator"
            ></fields-generator>

            <v-data-table
                class="background-2"
                :items="items"
                :headers="headers"
                :loading="loading"
                :footer-props="{
                    'items-per-page-options': [10, 25, 50,  { text: 'Tutti', value: -1 }]
                }">

                <template v-slot:item="{ item, headers, index }">
                    <tr :key="index">
                        <template v-for="(header, h) in headers">
                            <td v-if="header.value === 'number'" :class="cellClass(header)" :key="'num-'+h">
                                {{ index + 1 }}
                            </td>
                            <td v-else-if="getLinkRoute(header, item)" :class="cellClass(header)" :key="'link-'+h">
                                <router-link
                                    :to="getLinkRoute(header, item)"
                                    target="_blank"
                                    class="text-decoration-none link-cell"
                                    style="color: inherit;">
                                    <v-icon small class="mr-1" color="primary">mdi-open-in-new</v-icon>{{ item[header.value] }}
                                </router-link>
                            </td>
                            <td v-else-if="header.type == 'currency' && item.type != 'description'" :class="cellClass(header)" :key="'curr-'+h">
                                {{  item[header.value] | currency }}
                            </td>
                            <td v-else-if="header.subtype == 'squared-chip'" :class="cellClass(header)" :key="'sqchip-'+h">
                                <div v-if="item[header.value]" class="squared-chip" :style="item[header.value + '_color'] ? { color: item[header.value + '_color'], borderColor: item[header.value + '_color'] } : null">
                                    {{ item[header.value] }}
                                </div>
                            </td>
                            <td v-else-if="header.subtype == 'squared-chip-filled'" :class="cellClass(header)" :key="'sqfchip-'+h">
                                <div v-if="item[header.value]" class="squared-chip-filled" :style="item[header.value + '_color'] ? { backgroundColor: item[header.value + '_color'] } : null">
                                    <span :style="{ color: chipTextColor(item[header.value + '_color']) }">{{ item[header.value] }}</span>
                                </div>
                            </td>
                            <td v-else-if="header.subtype == 'chip'" :class="cellClass(header)" :key="'gtchip-'+h">
                                <v-chip
                                    v-if="item[header.value]"
                                    small
                                    :color="item[header.value + '_color'] || undefined"
                                    :text-color="chipTextColor(item[header.value + '_color'])">
                                    {{ item[header.value] }}
                                </v-chip>
                            </td>
                            <td v-else-if="header.type == 'chips'" :class="cellClass(header)" :key="'chip-'+h">
                                <v-chip v-for="(chip, c) in item[header.value]" small :key="c">{{ chip }}</v-chip>
                            </td>
                            <td v-else-if="header.type == 'datetime'" :class="cellClass(header)" :key="'dt-'+h">
                                {{ formatDateTime(item[header.value]) }}
                            </td>
                            <td v-else :class="cellClass(header)" :key="'txt-'+h">
                                {{ item[header.value] }}
                            </td>
                        </template>
                    </tr>
                </template>
            <template v-slot:footer.page-text="{ pageStart, pageStop }">
                Da {{ pageStart }} a {{ pageStop }} di {{ items.length }}
            </template>
            </v-data-table>
        </v-container>

        <v-slide-y-reverse-transition>

            <v-footer
                v-show="showFooter"
                height="auto"
                class="elevation-2 background-2"
                fixed
                app
                transition="slide-x-transition">
                <v-container class="py-2" fluid>

                    <v-row  justify="center">
                        <v-col class="pa-0" lg="2" md="2" sm="6" >
                            <v-list two-line class="w100p pa-0 background-2">
                                <v-list-item>
                                    <v-list-item-action>
                                        <v-icon color="primary">build</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>N. Interventi</v-list-item-title>
                                        <v-list-item-subtitle>{{ items.length }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-col>
                        <v-col class="pa-0" lg="2" md="2" sm="6" >
                            <v-list two-line class="w100p pa-0 background-2">
                                <v-list-item>
                                    <v-list-item-action>
                                        <v-icon color="primary">query_builder</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>Totale Ore</v-list-item-title>
                                        <v-list-item-subtitle>{{ totalTime }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-col>

                    </v-row>
                </v-container>
            </v-footer>
        </v-slide-y-reverse-transition>

        <v-fab-transition>
            <v-btn
                color="primary"
                v-model="showFooter"
                dark
                fab
                fixed
                bottom
                right
                @click="showFooter = !showFooter"
                >
                <v-icon v-if="showFooter">expand_more</v-icon>
                <v-icon v-else>expand_less</v-icon>
            </v-btn>
        </v-fab-transition>
    </v-card>
</template>

<script>
    import Vue from 'vue'

    export default {
        name: 'interventions-report',

        props: {
            modelDef: {
                type: String,
                default: 'interventionsreports'
            }
        },

        data() {
            return {
                fieldsset: {},
                headers: [],
                model: {
                    from: moment().startOf('month').format('YYYY-MM-DD'),
                    to: moment().endOf('month').format('YYYY-MM-DD'),
                },
                loaded: false,
                items: [],
                datepicker_menu: {},
                loading: false,
                showFooter: true,
            }
        },

        created() {
            this.axios.get(this.modelDef + '-info').then(response => {
                this.fieldsset = response.data.info.fields
                this.headers = response.data.info.headers

                _.forEach(this.fieldsset, (value, key) => {
                    if(value.default) {
                        Vue.set(this.model, value.key, value.default)
                    }
                })

                this.$store.commit('endProgress')

                this.getData()

            }, response => {
                // error callback
            });
        },

        computed: {

            isHelpdesk() {
                return this.modelDef === 'helpdeskinterventionsreports'
            },

            formatDateTime(datetime) {
                return (datetime) => {
                    return moment(datetime).format("DD/MM/YYYY HH:mm")
                }
            },

            totalTime() {
                let total_minutes = 0,
                    h = 0,
                    m = 0
                let result = '00:00'
                if(this.items.length > 0) {
                    _.forEach(this.items, (intervention) => {
                        let new_time = intervention.duration.split(':')
                        new_time[0] = parseInt(new_time[0]) * 60
                        new_time[1] = parseInt(new_time[1])

                        total_minutes = total_minutes +  new_time[0] + new_time[1]
                    })

                    h = total_minutes / 60 | 0,
                    m = total_minutes % 60 | 0

                    result = ''
                    if(h < 9) {
                        result = '0' + Math.round(h).toString() + ':'
                    } else {
                        result = Math.round(h).toString() + ':'
                    }
                    if(m < 9) {
                        result = result +  '0' + m.toString()
                    } else {
                        result = result + m.toString()
                    }
                }

                return result
            }
        },

        watch: {
            model: {
                handler() {
                    this.getData()
                },
                deep: true,
            },
        },

        methods: {

            getData() {

                this.loading = "warning"

                this.axios.post(this.modelDef, this.model).then(response => {
                    this.items = response.data.data
                    this.loading = false

                }, response => {
                    // error callback
                });
            },

            cellClass(header) {
                const align = 'text-' + (header.align ? header.align : 'left')
                return header.class ? align + ' ' + header.class : align
            },

            chipTextColor(bgColor) {
                if (!bgColor) return 'white'
                return this.$eventBusUtility.lightOrDark(bgColor) == 'dark' ? 'white' : 'black'
            },

            getLinkRoute(header, item) {
                const id = item[header.key]
                if (!id) return null

                switch (header.value) {
                    case 'company':
                        return { name: 'companies-show', params: { id } }
                    case 'destination':
                        return { name: 'companydestinations-show', params: { id } }
                    case 'trouble':
                        return {
                            name: this.isHelpdesk ? 'helpdesktroubles-show' : 'troubles-show',
                            params: { id }
                        }
                    case 'contract':
                        return {
                            name: this.isHelpdesk ? 'helpdeskcontracts-show' : 'contracts-show',
                            params: { id }
                        }
                    case 'asset':
                        return { name: 'assets-show', params: { id } }
                    default:
                        return null
                }
            },
        },
    }
</script>

<style>

</style>
